// --- Core ---
import React from "react";
import {each} from "underscore";
// --- SaniQ ---
import {Role} from "../models/Role";
import definitions from "vendor/qurasoft/definitions/permissions.json";
import {PermissionAccessLevel, PermissionDetailDefinition, PermissionKey} from "vendor/qurasoft/definitions/types/permissions";

type Permissions = {[K in PermissionKey]?: PermissionAccessLevel};

const initialState: Permissions = {};
const PermissionContext = React.createContext(initialState);
type PermissionBuilder = (roles: Role[]) => Permissions;

/**
 * Add nested read dependencies to the permissions if not already set
 */
const addDependencies = (result: Permissions, key: PermissionKey) => {
  const definition: PermissionDetailDefinition = definitions.permissions[key];

  each(definition?.dependencies, (dependency) => {
    if (!result[dependency]) {
      result[dependency] ||= 'read';
      addDependencies(result, dependency);
    }
  });
};

const buildPermissionsFromRoles: PermissionBuilder = (roles) => {
  //TODO(Keune): Think about applying enabled/disabled modules in here
  const result: Permissions = {};

  each(roles, role => {
    each(role.permissions, permission => {
      if (!(permission.key in result) || permission.access === "write") {
        result[permission.key] = permission.access;
      }
      addDependencies(result, permission.key);
    });
  });

  return result;
};

export {
  buildPermissionsFromRoles,
  PermissionContext,
  initialState as defaultPermissions
};
